import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router';

export default function NotFound() {
  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      p: 4,
    }}>
      <Typography variant="h3">404</Typography>
      <Typography color="text.secondary">That page doesn't exist.</Typography>
      <Button component={Link} to="/" variant="contained">Back home</Button>
    </Box>
  );
}
